<template>
  <div>
    <h5 class="headline">{{ $t("contract.duration_and_resignation.headline") }}</h5>
    <p class="user-output" v-for="(paragraph, index) in paragraphs" :key="paragraph">{{ `11.${index + 1}.\t${paragraph}` }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  methods: {
    formatDate(date) {
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }
  },
  computed: {
    isDistributor() {
      return this.$store.getters.isDistributorType;
    },
    durationAndResignation() {
      return this.$store.state.contract.durationAndResignation;
    },
    durationType() {
      return this.durationAndResignation.selectedDuration;
    },
    earliestResignationDate() {
      let date = this.durationAndResignation.earliestResignation;
      return date !== "" ? this.formatDate(date) : this.$t("contract.duration_and_resignation.placeholder.date");
    },
    fromDate() {
      let date = this.durationAndResignation.fromDate;
      return date !== "" ? this.formatDate(date) : this.$t("contract.duration_and_resignation.placeholder.date");
    },
    toDate() {
      let date = this.durationAndResignation.toDate;
      return date !== "" ? this.formatDate(date) : this.$t("contract.duration_and_resignation.placeholder.date");
    },
    period() {
      return this.durationAndResignation.period !== "" ? this.durationAndResignation.period : this.$t("contract.duration_and_resignation.placeholder.period");
    },
    paragraphs() {
      let ps = [];

      switch (this.durationType) {
        case "Unlimited":
        case "Tidsubegrænset":
          ps.push(this.$t("contract.duration_and_resignation.unlimited.paragraph_one"));
          ps.push(this.$t("contract.duration_and_resignation.unlimited.paragraph_two"));
          if (this.isDistributor) {
            ps.push(this.$t("contract.duration_and_resignation.unlimited.paragraph_three", { date: this.earliestResignationDate }));
            ps.push(this.$t("contract.duration_and_resignation.unlimited.paragraph_four"));
          }
          break;
        case "Limited period with automatic renewal":
        case "Fast periode med automatisk fornyelse":
          ps.push(this.$t("contract.duration_and_resignation.limited_auto_renew.paragraph_one", { fromDate: this.fromDate, toDate: this.toDate }));
          break;
        default:
          break;
      }

      return ps;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/DurationAndResignationOutput.vue